<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="160px">
        <div class="filter-col">
          <el-form-item label="购房人姓名：">
            <el-input clearable v-model="filterForm.name" placeholder="请输入购房人姓名"></el-input>
          </el-form-item>
          <el-form-item label="所购楼盘名称：">
            <el-input clearable v-model="filterForm.house" placeholder="请输入所购楼盘名称"></el-input>
          </el-form-item>
          <el-form-item label="户籍地址：">
            <el-select clearable filterable v-model="filterForm.address" placeholder="请选择户籍地址">
              <el-option v-for="(x2, i2) in options.address" :key="i2" :label="x2" :value="x2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="filter-col">
          <!-- <el-form-item label="是否就业：">
            <el-radio-group v-model="filterForm.personHasJob">
              <el-radio label="">不限</el-radio>
              <el-radio label="是" />
              <el-radio label="否" />
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="是否有求职意愿：">
            <el-radio-group v-model="filterForm.jobWith">
              <el-radio label="">不限</el-radio>
              <el-radio label="是" />
              <el-radio label="否" />
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否有培训意愿：">
            <el-radio-group v-model="filterForm.trainWish">
              <el-radio label="">不限</el-radio>
              <el-radio label="是" />
              <el-radio label="否" />
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="filter-col">
          <el-form-item label="开始时间：" prop="startCreateTime">
            <el-date-picker type="date" v-model="filterForm.startCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="结束时间：" prop="endCreateTime">
            <el-date-picker type="date" v-model="filterForm.endCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button>
      <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->
        <el-table-column  type="selection" width="40" :selectable="banCheck"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 -->
    <el-dialog :visible.sync="isShowDialog" :close-on-click-modal="true" :title="dialogTitle" center width="1260px" class="dialog">
      <div>
        <!-- 购房人信息 -->
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">购房人信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form ref="form" :model="eData" :rules="rules" label-width="240px" :disabled="isView">
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="购房人姓名：">
                          <el-input clearable size="mini" style="width:360px;" v-model="eData.name" placeholder="未填写"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：">
                          <el-input clearable size="mini" style="width:360px;" v-model="eData.phone" placeholder="未填写"></el-input>
                        </el-form-item>
                        <el-form-item label="户籍地址：">
                          <el-select clearable filterable size="mini" style="width:360px;" v-model="eData.address" placeholder="未选择">
                            <el-option v-for="(x2, i2) in options.address" :key="i2" :label="x2" :value="x2"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="户籍地址-其他：" v-if="eData.address==='其他'">
                          <el-input clearable size="mini" style="width:360px;" v-model="eData.address_other" placeholder="未填写"></el-input>
                        </el-form-item>
                        <el-form-item label="所购楼盘名称：">
                          <el-autocomplete
                            clearable filterable size="mini" style="width:360px;" v-model="eData.house"
                            :fetch-suggestions="querySearchAsync" placeholder="未选择"></el-autocomplete>
                        </el-form-item>
                        <template>
                          <!-- #region 就业 -->
                          <el-form-item label="是否就业：">
                            <el-radio-group v-model="eData.hostInfo.personHasJob">
                              <el-radio label="是" />
                              <el-radio label="否" />
                            </el-radio-group>
                          </el-form-item>
                          <template v-if="eData.hostInfo.personHasJob==='是'">
                            <el-form-item label="就业方式：">
                              <el-radio-group v-model="eData.hostInfo.jobSelect">
                                <el-radio label="单位就业" />
                                <el-radio label="灵活就业" />
                              </el-radio-group>
                            </el-form-item>
                            <el-form-item label="单位名称：" v-if="eData.hostInfo.jobSelect==='单位就业'">
                              <el-input clearable size="mini" style="width:360px;" v-model="eData.hostInfo.organizationName" placeholder="未填写"></el-input>
                            </el-form-item>
                            <el-form-item label="灵活就业类型：" v-if="eData.hostInfo.jobSelect==='灵活就业'">
                              <el-select clearable filterable size="mini" style="width:360px;" v-model="eData.hostInfo.jobStyle" placeholder="未选择">
                                <el-option v-for="(x2, i2) in options.jobStyle" :key="i2" :label="x2" :value="x2"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="灵活就业类型-其他：" v-if="eData.hostInfo.jobSelect==='灵活就业'&&eData.hostInfo.jobStyle==='其他'">
                              <el-input clearable size="mini" style="width:360px;" v-model="eData.hostInfo.jobStyleOther" placeholder="未填写"></el-input>
                            </el-form-item>
                          </template>
                          <!-- #endregion -->
                          <!-- #region 求职 -->
                          <template v-if="eData.hostInfo.personHasJob==='否'">
                            <el-form-item label="是否有求职意愿：">
                              <el-radio-group v-model="eData.hostInfo.jobWith">
                                <el-radio label="是" />
                                <el-radio label="否" />
                              </el-radio-group>
                            </el-form-item>
                            <el-form-item label="意向行业：" v-if="eData.hostInfo.jobWith==='是'">
                              <el-select clearable filterable size="mini" style="width:360px;" v-model="eData.hostInfo.jobDomain" placeholder="未选择">
                                <el-option v-for="(x2, i2) in options.jobDomain" :key="i2" :label="x2" :value="x2"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="意向行业-其他：" v-if="eData.hostInfo.jobWith==='是'&&eData.hostInfo.jobDomain==='其他'">
                              <el-input clearable size="mini" style="width:360px;" v-model="eData.hostInfo.jobDomainOther" placeholder="未填写"></el-input>
                            </el-form-item>
                          </template>
                          <!-- #endregion -->
                          <!-- #region 培训 -->
                          <el-form-item label="是否有培训意愿：">
                            <el-radio-group v-model="eData.hostInfo.trainWish">
                              <el-radio label="是" />
                              <el-radio label="否" />
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="意向工种：" v-if="eData.hostInfo.trainWish==='是'">
                            <el-select clearable filterable size="mini" style="width:360px;" v-model="eData.hostInfo.trainDomain" placeholder="未选择">
                              <el-option v-for="(x2, i2) in options.trainDomain" :key="i2" :label="x2" :value="x2"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="意向工种-其他：" v-if="eData.hostInfo.trainWish==='是'&&eData.hostInfo.trainDomain==='其他'">
                            <el-input clearable size="mini" style="width:360px;" v-model="eData.hostInfo.trainDomainOther" placeholder="未填写"></el-input>
                          </el-form-item>
                          <!-- #endregion -->
                          <!-- #region 个人信息 -->
                          <template v-if="eData.hostInfo.jobWith==='是'||eData.hostInfo.trainWish==='是'">
                            <!-- <el-form-item label="姓名：">
                              <el-input clearable size="mini" style="width:360px;" v-model="eData.hostInfo.name" placeholder="未填写"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号：">
                              <el-input clearable size="mini" style="width:360px;" v-model="eData.hostInfo.phone" placeholder="未填写"></el-input>
                            </el-form-item> -->
                            <el-form-item label="性别：">
                              <el-radio-group v-model="eData.hostInfo.sex">
                                <el-radio label="男" />
                                <el-radio label="女" />
                              </el-radio-group>
                            </el-form-item>
                            <el-form-item label="身份证号：">
                              <el-input clearable size="mini" style="width:360px;" v-model="eData.hostInfo.idCard" placeholder="未填写" @blur="idCardInput(eData.hostInfo)"></el-input>
                            </el-form-item>
                            <el-form-item label="学历：">
                              <el-select clearable filterable size="mini" style="width:360px;" v-model="eData.hostInfo.education" placeholder="未选择">
                                <el-option v-for="(x2, i2) in options.education" :key="i2" :label="x2" :value="x2"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="学历-其他：" v-if="eData.hostInfo.trainWish==='是'&&eData.hostInfo.education==='其他'">
                              <el-input clearable size="mini" style="width:360px;" v-model="eData.hostInfo.educationOther" placeholder="未填写"></el-input>
                            </el-form-item>
                            <el-form-item label="毕业学校：">
                              <el-input clearable size="mini" style="width:360px;" v-model="eData.hostInfo.school" placeholder="未填写"></el-input>
                            </el-form-item>
                            <el-form-item label="工作经历：">
                              <el-input type="textarea" maxlength="2000" clearable size="mini" style="width:360px;" v-model="eData.hostInfo.workExperience" placeholder="未填写"></el-input>
                            </el-form-item>
                          </template>
                          <!-- #endregion -->
                        </template>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 家庭成员 -->
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">家庭成员</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form ref="form" :model="eData" :rules="rules" label-width="240px" :disabled="isView">
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="成员人数（16-60岁，含购房人）：">
                          <el-input-number clearable size="mini" v-model="eData.persons" :min="0" placeholder="未填写"></el-input-number>
                        </el-form-item>
                        <template v-for="(x,i) in eData.familyInfoList">
                          <div class="subtitle">
                            <div>成员{{i+1}}</div>
                            <div class="btns" v-if="!isView">
                              <i class="el-icon-plus icon" @click="addClick(i)"></i>
                              <i class="el-icon-minus icon ml20" @click="subtractClick(i)" v-if="eData.familyInfoList.length>1"></i>
                            </div>
                          </div>
                          <!-- <el-form-item label="姓名：">
                            <el-input clearable size="mini" style="width:360px;" v-model="x.name" placeholder="未填写"></el-input>
                          </el-form-item> -->
                          <!-- #region 就业 -->
                          <el-form-item label="是否就业：">
                            <el-radio-group v-model="x.personHasJob">
                              <el-radio label="是" />
                              <el-radio label="否" />
                            </el-radio-group>
                          </el-form-item>
                          <template v-if="x.personHasJob==='是'">
                            <el-form-item label="就业方式：">
                              <el-radio-group v-model="x.jobSelect">
                                <el-radio label="单位就业" />
                                <el-radio label="灵活就业" />
                              </el-radio-group>
                            </el-form-item>
                            <el-form-item label="单位名称：" v-if="x.jobSelect==='单位就业'">
                              <el-input clearable size="mini" style="width:360px;" v-model="x.organizationName" placeholder="未填写"></el-input>
                            </el-form-item>
                            <el-form-item label="灵活就业类型：" v-if="x.jobSelect==='灵活就业'">
                              <el-select clearable filterable size="mini" style="width:360px;" v-model="x.jobStyle" placeholder="未选择">
                                <el-option v-for="(x2, i2) in options.jobStyle" :key="i2" :label="x2" :value="x2"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="灵活就业类型-其他：" v-if="x.jobSelect==='灵活就业'&&x.jobStyle==='其他'">
                              <el-input clearable size="mini" style="width:360px;" v-model="x.jobStyleOther" placeholder="未填写"></el-input>
                            </el-form-item>
                          </template>
                          <!-- #endregion -->
                          <!-- #region 求职 -->
                          <template v-if="x.personHasJob==='否'">
                            <el-form-item label="是否有求职意愿：">
                              <el-radio-group v-model="x.jobWith">
                                <el-radio label="是" />
                                <el-radio label="否" />
                              </el-radio-group>
                            </el-form-item>
                            <el-form-item label="意向行业：" v-if="x.jobWith==='是'">
                              <el-select clearable filterable size="mini" style="width:360px;" v-model="x.jobDomain" placeholder="未选择">
                                <el-option v-for="(x2, i2) in options.jobDomain" :key="i2" :label="x2" :value="x2"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="意向行业-其他：" v-if="x.jobWith==='是'&&x.jobDomain==='其他'">
                              <el-input clearable size="mini" style="width:360px;" v-model="x.jobDomainOther" placeholder="未填写"></el-input>
                            </el-form-item>
                          </template>
                          <!-- #endregion -->
                          <!-- #region 培训 -->
                          <el-form-item label="是否有培训意愿：">
                            <el-radio-group v-model="x.trainWish">
                              <el-radio label="是" />
                              <el-radio label="否" />
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="意向工种：" v-if="x.trainWish==='是'">
                            <el-select clearable filterable size="mini" style="width:360px;" v-model="x.trainDomain" placeholder="未选择">
                              <el-option v-for="(x2, i2) in options.trainDomain" :key="i2" :label="x2" :value="x2"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="意向工种-其他：" v-if="x.trainWish==='是'&&x.trainDomain==='其他'">
                            <el-input clearable size="mini" style="width:360px;" v-model="x.trainDomainOther" placeholder="未填写"></el-input>
                          </el-form-item>
                          <!-- #endregion -->
                          <!-- #region 个人信息 -->
                          <template v-if="x.jobWith==='是'||x.trainWish==='是'">
                            <el-form-item label="姓名：">
                              <el-input clearable size="mini" style="width:360px;" v-model="x.name" placeholder="未填写"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号：">
                              <el-input clearable size="mini" style="width:360px;" v-model="x.phone" placeholder="未填写"></el-input>
                            </el-form-item>
                            <el-form-item label="性别：">
                              <el-radio-group v-model="x.sex">
                                <el-radio label="男" />
                                <el-radio label="女" />
                              </el-radio-group>
                            </el-form-item>
                            <el-form-item label="身份证号：">
                              <el-input clearable size="mini" style="width:360px;" v-model="x.idCard" placeholder="未填写" @blur="idCardInput(x)"></el-input>
                            </el-form-item>
                            <el-form-item label="学历：">
                              <el-select clearable filterable size="mini" style="width:360px;" v-model="x.education" placeholder="未选择">
                                <el-option v-for="(x2, i2) in options.education" :key="i2" :label="x2" :value="x2"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="学历-其他：" v-if="x.trainWish==='是'&&x.education==='其他'">
                              <el-input clearable size="mini" style="width:360px;" v-model="x.educationOther" placeholder="未填写"></el-input>
                            </el-form-item>
                            <el-form-item label="毕业学校：">
                              <el-input clearable size="mini" style="width:360px;" v-model="x.school" placeholder="未填写"></el-input>
                            </el-form-item>
                            <el-form-item label="工作经历：">
                              <el-input type="textarea" maxlength="2000" clearable size="mini" style="width:360px;" v-model="x.workExperience" placeholder="未填写"></el-input>
                            </el-form-item>
                          </template>
                          <!-- #endregion -->
                        </template>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 服务日志录入 -->
        <div class="edit-box" v-show="!isCreate">
          <div class="edit-item">
            <div class="edit-left">服务日志录入</div>
            <div class="edit-right"  style="padding-top: 0">
              <div class="info-box">
                <div class="info-input">
                  <el-form ref="form" :model="eData" :rules="rules" label-width="150px">
                    <el-row style="margin-top:20px">
                      <el-col>
                        <el-form-item label="服务类型：">
                          <el-radio-group v-model="logFrom.serviceType">
                            <!-- <el-radio :label="x2.value" v-for="(x2,i2) in logTypes" :key="i2">{{x2.label}}</el-radio> -->
                            <el-radio :label="x2.label" v-for="(x2,i2) in logTypes" :key="i2">{{x2.label}}</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="服务对象姓名：">
                          <!-- <el-input clearable size="mini" style="width:360px;" v-model="logFrom.targetName"></el-input> -->
                          <el-select clearable filterable size="mini" style="width:360px;" v-model="logFrom.targetName" placeholder="未选择">
                            <el-option v-for="(x2, i2) in this.selectData.users" :key="i2" :label="x2" :value="x2"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="服务对象电话号码：">
                          <!-- <el-input clearable size="mini" style="width:360px;" v-model="logFrom.targetPhone"></el-input> -->
                          <el-select clearable filterable size="mini" style="width:360px;" v-model="logFrom.targetPhone" placeholder="未选择">
                            <el-option v-for="(x2, i2) in this.selectData.tels" :key="i2" :label="x2" :value="x2"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="服务内容：">
                          <el-input type="textarea" v-model="logFrom.serviceContent" :rows="3"></el-input>
                        </el-form-item>
                        <el-form-item label="服务结果：">
                          <el-input type="textarea" v-model="logFrom.serviceResult" :rows="3"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="上传图片：">
                          <div style="width: 100%;" id="img">
                            <el-upload
                              ref="uploadImg" list-type="picture-card" :class="{disabled:isMax}"
                              :action="$api.url_upload_pu" :file-list="fileList" :limit="3" 
                              :on-success="uploadSuccess" :on-error="uploadError"
                              :on-preview="imagePreview" :on-remove="uploadRemove">
                              <i class="el-icon-plus"></i>
                            </el-upload>
                          </div>
                        </el-form-item>
                        <el-form-item>
                          <div style="margin: 10px 10px 0 0;float:right;">
                            <el-button type="primary" v-show="!isCreate" @click="submitLog()">提交日志</el-button>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 服务记录查询 -->
        <div class="edit-box" v-show="!isCreate">
          <div class="edit-item">
            <div class="edit-left">服务记录查询</div>
            <div class="edit-right"  style="padding-top: 0;flex: 0 0 95%;">
              <div class="info-box">
                <div class="info-input">
                  <el-table :data="logData" max-height="500" border style="width: 99.9%">
                    <el-table-column
                      v-for="x1 in logItems" :key="x1.key" show-overflow-tooltip
                      :prop="x1.key" :label="x1.value" align="center">
                    </el-table-column>
                    <el-table-column label="图片" type="expand">
                      <template slot-scope="props">
                        <div v-if="props.row.imgList">
                          <span v-for="(x2,i2) in props.row.imgList_" :key="i2" style="margin-left: 10px">
                            <el-image style="width:100px;height:100px" :src="x2" :preview-src-list="props.row.imgList_" />
                          </span>
                        </div>
                        <div v-else>
                          <span>无详情图片</span>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <Pagenation :pageData="pageData_log" @pageChange="pageChange_log"></Pagenation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 足部 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogEditSubmit">确 定</el-button>
        <el-button @click="clearDialogEdit">取 消</el-button>
      </div>
    </el-dialog>
    
    <el-dialog :visible.sync="dialogVisible" :modal="false">
      <img width="100%" :src="previewImageUrl" alt="">
    </el-dialog>

  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogView from '@/components/DialogView'
import Pagenation from '@/components/Pagenation'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
const eData_copy = {
  name: '',
  phone: '',
  address: '',
  address_other: '',
  house: '',
  persons: '',
  hostInfo: {
    personHasJob: '', // 是否就业
    jobSelect: '', // 就业方式
    organizationName: '', // 单位名称
    jobStyle: '', // 灵活就业类型
    jobStyleOther: '', // 灵活就业类型
    jobWith: '', // 求职意愿
    jobDomain: '', // 意向行业
    jobDomainOther: '', // 意向行业
    trainWish: '', // 培训意愿
    trainDomain: '', // 意向工种
    trainDomainOther: '', // 意向工种
    // name: '', // 姓名
    // phone: '', // 手机号
    sex: '', // 性别
    idCard: '', // 身份证号码
    education: '', // 学历
    educationOther: '', // 学历
    school: '', // 毕业学校
    workExperience: '', // 工作经历
  },
  familyInfoList: [
    {
      personHasJob: '', // 是否就业
      jobSelect: '', // 就业方式
      organizationName: '', // 单位名称
      jobStyle: '', // 灵活就业类型
      jobStyleOther: '', // 灵活就业类型
      jobWith: '', // 求职意愿
      jobDomain: '', // 意向行业
      jobDomainOther: '', // 意向行业
      trainWish: '', // 培训意愿
      trainDomain: '', // 意向工种
      trainDomainOther: '', // 意向工种
      name: '', // 姓名
      phone: '', // 手机号
      sex: '', // 性别
      idCard: '', // 身份证号码
      education: '', // 学历
      educationOther: '', // 学历
      school: '', // 毕业学校
      workExperience: '', // 工作经历
    }
  ]
}
export default {
  mixins: [mixins], 
  components: { DialogView,  Pagenation },
  data() {
    return {
      sign: 'questionnaire_jionCity',
      dialogTitle: '人口进城调查',
      fileName: 'questionnaire_jionCity',

      baseInfo: [
        { key: 'nameT', label: '购房人姓名', fixed: true },
        { key: 'phoneT', label: '电话', fixed: true },
        { key: 'addressT', label: '户籍地址' },
        { key: 'houseT', label: '所购楼盘名称' },
        { key: 'personHasJobT', label: '是否就业' },
        { key: 'jobWithT', label: '是否有求职意愿' },
        { key: 'trainWishT', label: '是否有培训意愿' },
      ],

      options: {
        address: ['玉州','福绵','兴业','北流','容县','博白','陆川','其他'],
        jobStyle: ['摆地摊','保洁','保安','建筑工','其他'],
        jobDomain: [
          '农、林、牧、渔',
          '制造业',
          '交通运输、仓储和邮政业',
          '建筑业',
          '批发和零售业',
          '住宿和餐饮业',
          '金融业',
          '房地产业',
          '租赁和商务服务',
          '科学研究、技术服务和地址勘察业',
          '水利、环境和公共设施管理业',
          '居民服务和其他服务',
          '教育',
          '卫生、社会保障和社会福利业',
          '其他'
        ],
        trainDomain: ['中式面点师','中式烹饪师','家政服务员','保育员','茶艺师','育婴师','其他'],
        education: ['研究生','本科','大专','高中或高职','初中或中专','小学','其他']
      },
      eData: {
        name: '',
        phone: '',
        address: '',
        address_other: '',
        house: '',
        persons: '',
        hostInfo: {
          personHasJob: '', // 是否就业
          jobSelect: '', // 就业方式
          organizationName: '', // 单位名称
          jobStyle: '', // 灵活就业类型
          jobStyleOther: '', // 灵活就业类型
          jobWith: '', // 求职意愿
          jobDomain: '', // 意向行业
          jobDomainOther: '', // 意向行业
          trainWish: '', // 培训意愿
          trainDomain: '', // 意向工种
          trainDomainOther: '', // 意向工种
          // name: '', // 姓名
          // phone: '', // 手机号
          sex: '', // 性别
          idCard: '', // 身份证号码
          education: '', // 学历
          educationOther: '', // 学历
          school: '', // 毕业学校
          workExperience: '', // 工作经历
        },
        familyInfoList: [
          {
            personHasJob: '', // 是否就业
            jobSelect: '', // 就业方式
            organizationName: '', // 单位名称
            jobStyle: '', // 灵活就业类型
            jobStyleOther: '', // 灵活就业类型
            jobWith: '', // 求职意愿
            jobDomain: '', // 意向行业
            jobDomainOther: '', // 意向行业
            trainWish: '', // 培训意愿
            trainDomain: '', // 意向工种
            trainDomainOther: '', // 意向工种
            name: '', // 姓名
            phone: '', // 手机号
            sex: '', // 性别
            idCard: '', // 身份证号码
            education: '', // 学历
            educationOther: '', // 学历
            school: '', // 毕业学校
            workExperience: '', // 工作经历
          }
        ]
      },

      isShowDialog: false,
      isView: false,
      rules: null,


      // #region 日志
      logItems: [
        { value: '服务类型', key: 'serviceType' },
        { value: '服务内容', key: 'serviceContent' },
        { value: '服务结果', key: 'serviceResult' },
        { value: '服务对象姓名', key: 'targetName' },
        { value: '服务对象电话号码', key: 'targetPhone' },
        { value: '操作人姓名', key: 'operatorName' },
        { value: '操作时间', key: 'operatorDate' },
      ],
      logTypes: [
        // { label: '结对帮扶', value: 0 },
        { label: '信息采集', value: 1 },
        { label: '就业服务', value: 2 },
        { label: '培训服务', value: 3 },
        { label: '创业服务', value: 4 },
        { label: '维权服务', value: 5 },
        { label: '其它服务', value: 6 },
      ],
      logFrom: {
        serviceType: '',
        imgList: [],
        targetName: '',
        targetPhone: '',
        serviceContent: '',
        serviceResult: '',
      },
      previewImageUrl: '',
      fileList: [],
      isMax: false,
      dialogVisible: false,
      pageData_log: {
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
      pageIndex_log: 1,
      logData: [],
      // #endregion
    }
  },
  computed: {
    importAction() {
      return this.$api.baseUrl + '/invest/import'
    },
  },
  methods: {
    // 禁止勾选
    banCheck(row, index) {
      // console.log(`%crow, index:`, 'color: #00f;', row, index)
      if (row.member) {
        return false
      } else {
        return true
      }
    },
    // 点击选中
    selectHandler(cRow, oRow) {
      // console.log(`%ccRow, oRow:`, 'color: #f00;', cRow, oRow)
      if (cRow.member) {
        return
      }
      this.selectRows = [JSON.parse(JSON.stringify(cRow))]
      this.selectData = JSON.parse(JSON.stringify(cRow))
    },


    // #region 按钮操作
    // 查询
    searchHandler() {
      let rD = this.beforeSearchAndExportHandler(this.filterForm)
      rD.pageNumber = this.pageData.currentPage
      rD.familyInfoList = [
        {
          jobWith: rD.jobWith,
          trainWish: rD.trainWish,
        }
      ]
      delete rD.jobWith
      delete rD.trainWish
      // console.log(rD)
      this.getData(rD)
    },
    // 导出
    exportHandler() {
      console.log(`%cfilterForm:`, 'color: #00f;', this.filterForm)
      let rD = this.beforeSearchAndExportHandler(this.filterForm)

      let loadingInstance = Loading.service({
        lock: true,
        text: '导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        fullscreen: true 
      })
      this.$api.util_export(this.sign, rD).then(res => {
        if (res.data.status == 0) {
          let _R = res.data.data
          this.downloadFun(_R)
          this.$nextTick(() => { loadingInstance.close() })
        } else {
          this._status(res.data)
          this.$nextTick(() => { loadingInstance.close() })
        }
      })
    },
    // 创建
    createHandler() {
      this.isView = false
      this.isCreate = true
      this.eData = JSON.parse(JSON.stringify(eData_copy))
      this.isShowDialog = true
    },
    // 编辑
    modifyHandler() {
      console.log(`%cthis.selectData:`, 'color: #f00;', this.selectData)
      if (this.selectData) {
        this.isView = false
        this.isCreate = false
        this.eData = JSON.parse(JSON.stringify(this.selectData))
        this.getLogs(this.pageData_log.currentPage, this.selectData.id)
        this.isShowDialog = true
      }
    },
    // 查看
    viewHandler() {
      console.log(`%cthis.selectData:`, 'color: #f00;', this.selectData)
      if (this.selectData) {
        this.isView = true
        this.isCreate = false
        this.eData = JSON.parse(JSON.stringify(this.selectData))
        this.getLogs(this.pageData_log.currentPage, this.selectData.id)
        this.isShowDialog = true
      }
    },
    // #endregion
    
    // #region 对话框操作
    // 清空查看对话框
    clearDialogView() {
      this.eData = JSON.parse(JSON.stringify(eData_copy))
      this.isShowDialog = false
    },
    // 清空编辑对话框
    clearDialogEdit() {
      this.eData = JSON.parse(JSON.stringify(eData_copy))
      this.isShowDialog = false
    },
    // 提交编辑对话框
    dialogEditSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const rD = this.eData
          console.log(`%cresult:`, 'color: #00f;', rD)
          rD.address !== '其他' && (rD.address_other = '')
          rD.familyInfoList.forEach(x1 => {
            x1.jobSelect === '单位就业' && (rD.jobStyle = '')
            x1.jobSelect === '灵活就业' && (rD.organizationName = '')
            x1.jobStyle !== '其他' && (rD.jobStyleOther = '')
            x1.jobDomain !== '其他' && (rD.jobDomainOther = '')
            x1.trainDomain !== '其他' && (rD.trainDomainOther = '')
            x1.education !== '其他' && (rD.educationOther = '')
          })
          let flag = true
          if (rD.name === '') {
            this.$message.warning('购房人姓名必填')
            flag = false
          } else if (rD.phone.length !== 11) {
            this.$message.warning('电话必须11位')
            flag = false
          } else if (rD.address === '') {
            this.$message.warning('户籍地址必选')
            flag = false
          } else if (rD.house === '') {
            this.$message.warning('所购楼盘名称必选')
            flag = false
          } else {

            rD.familyInfoList.forEach((x1, i1) => {
              if (x1.name === '') {
                this.$message.warning(`成员${i1+1}姓名必填`)
                flag = false
              } else if (x1.personHasJob === '') {
                this.$message.warning(`成员${i1+1}是否就业必选`)
                flag = false
              } else if (x1.personHasJob === '否' && x1.jobWith === '') {
                this.$message.warning(`成员${i1+1}是否有求职意愿必选`)
                flag = false
              } else if (x1.trainWish === '') {
                this.$message.warning(`成员${i1+1}是否有培训意愿必选`)
                flag = false
              } else if (x1.jobWith === '是' || x1.trainWish === '是') {
                if (x1.name === '') {
                  this.$message.warning(`成员${i1+1}姓名必填`)
                  flag = false
                } else if (x1.phone.length !== 11) {
                  this.$message.warning(`成员${i1+1}手机号必须11位`)
                  flag = false
                } else if (x1.sex === '') {
                  this.$message.warning(`成员${i1+1}性别必选`)
                  flag = false
                } else if (x1.idCard === '') {
                  this.$message.warning(`成员${i1+1}身份证号必填`)
                  flag = false
                } else if (x1.education === '') {
                  this.$message.warning(`成员${i1+1}学历必选`)
                  flag = false
                }
              }
            })


            if (rD.hostInfo.personHasJob === '') {
              this.$message.warning(`业主是否就业必选`)
              flag = false
            } else if (rD.hostInfo.personHasJob === '否' && rD.hostInfo.jobWith === '') {
              this.$message.warning(`业主是否有求职意愿必选`)
              flag = false
            } else if (rD.hostInfo.trainWish === '') {
              this.$message.warning(`业主是否有培训意愿必选`)
              flag = false
            } else if (rD.hostInfo.jobWith === '是' || rD.hostInfo.trainWish === '是') {
              // if (rD.hostInfo.name === '') {
              //   this.$message.warning(`业主姓名必填`)
              //   flag = false
              // } else if (rD.hostInfo.phone.length !== 11) {
              //   this.$message.warning(`业主手机号必须11位`)
                // flag = false
              // } else 
              if (rD.hostInfo.sex === '') {
                this.$message.warning(`业主性别必选`)
                flag = false
              } else if (rD.hostInfo.idCard === '') {
                this.$message.warning(`业主身份证号必填`)
                flag = false
              } else if (rD.hostInfo.education === '') {
                this.$message.warning(`业主学历必选`)
                flag = false
              }
            }
            
          }

          let rData = {}
          if (!flag) {
            return
          } else if (this.isCreate) {
            rData = JSON.parse(JSON.stringify(rD))
            this.$api.util_create(this.sign, rData).then(res => {
              if (res.data.status == 0) {
                this.$message.success('创建成功！')
                this.isShowDialog = false
                this.clearDialogEdit()
                this.searchHandler()
              } else { this._status(res.data) }
            })
          } else {
            rData = JSON.parse(JSON.stringify(rD))
            rData.id = this.selectData.id // 绑定修改的数据id
            console.log(rData)
            delete rData.createTime
            this.$api.util_modify(this.sign, rData).then(res => {
              if (res.data.status == 0) {
                this.$message.success('修改成功！')
                this.isShowDialog = false
                this.clearDialogEdit()
                this.searchHandler()
              } else { this._status(res.data) }
            })
          }
        }
      })
    },
    // #endregion

    // #region 楼盘+成员+身份证验证
    querySearchAsync(querykey, cb) {
      console.log(querykey)
      this.$api.getQuestionnaireJionCityBuildings({ house: querykey }).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          _R = _R.map(x => ({
            label: x.house,
            value: x.house,
          }))
          console.log(_R)
          cb(_R)
        } else { this._status(res.data) }
      })
    },
    // 点击了添加一个成员
    addClick(index) {
      this.eData.familyInfoList.splice(index + 1, 0, {
        personHasJob: '', // 是否就业
        jobSelect: '', // 就业方式
        organizationName: '', // 单位名称
        jobStyle: '', // 灵活就业类型
        jobStyleOther: '', // 灵活就业类型
        jobWith: '', // 求职意愿
        jobDomain: '', // 意向行业
        jobDomainOther: '', // 意向行业
        trainWish: '', // 培训意愿
        trainDomain: '', // 意向工种
        trainDomainOther: '', // 意向工种
        name: '', // 姓名
        phone: '', // 手机号
        sex: '', // 性别
        idCard: '', // 身份证号码
        education: '', // 学历
        educationOther: '', // 学历
        school: '', // 毕业学校
        workExperience: '', // 工作经历
      })
    },
    // 点击了减少一个成员
    subtractClick(index) {
      this.eData.familyInfoList.length > 1 && this.eData.familyInfoList.splice(index, 1)
    },
    idCardInput(item) {
      let value = item.idCard
      console.log(value)
      let reg = new RegExp(/^[1-8][1-7]\d{4}(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/)
      let result = reg.test(value)
      console.log(`%cresult:`, 'color: #f00;', result)
      if (!result) {
        this.$message.warning('请输入合规的18位号码')
        item.idCard = ''
      }
    },
    // #endregion

    // #region 日志
    //图片预览
    imagePreview(file) {
      this.previewImageUrl = file.url
      this.dialogVisible = true
    },
    //图片移除
    uploadRemove(file, fileList) {
      this.uploadChange(file, fileList)
    },
    //图片上传成功回调
    uploadSuccess(response, file, fileList) {
      this.uploadChange(file, fileList)
    },
    //图片上传失败
    uploadError(err, file, fileList) {
      this.uploadChange(file, fileList)
    },
    //图片状态改变时触发
    uploadChange(file, fileList) {
      console.log(`%cfileList:`, 'color: #f00;', file, fileList)
      this.fileList = fileList
      this.isMax = fileList.length >= 3
      fileList.forEach(x => {
        this.logFrom.imgList.push(JSON.parse(x.response.data).fileId)
      })
    },
    //提交日志请求
    submitLog() {
      // console.log(this.logFrom, this.fileList)
      if (!this.logFrom.serviceType) {
        this.$message.warning('请选择服务类型')
      } else if (!this.logFrom.targetName) {
        this.$message.warning('请输入服务对象姓名')
      } else if (!this.logFrom.targetPhone) {
        this.$message.warning('请输入服务对象电话号码')
      } else if (!this.logFrom.serviceContent) {
        this.$message.warning('请输入服务内容')
      } else if (!this.logFrom.serviceResult) {
        this.$message.warning('请输入服务结果')
      } else {
        let rD = {
          investId: this.selectData.id,
          serviceType: this.logFrom.serviceType,
          targetName: this.logFrom.targetName,
          targetPhone: this.logFrom.targetPhone,
          imgList: this.logFrom.imgList,
          serviceContent: this.logFrom.serviceContent,
          serviceResult: this.logFrom.serviceResult
        }
        this.$api.util_create('questionnaire_log', rD).then( res=> {
          if (res.data.status == 0) {
            this.$message.success('提交日志成功！')
            this.$refs.uploadImg.clearFiles()
            this.logFrom = {
              serviceType: '',
              imgList: [],
              targetName: '',
              targetPhone: '',
              serviceContent: '',
              serviceResult: '',
            }
            this.fileList = []
            this.isMax = false
            this.getLogs(this.pageData_log.currentPage, this.selectData.id)
          } else { this._status(res.data) }
        })
      }
    },
    //日志分页
    pageChange_log(pageNumber) {
      this.getLogs(pageNumber, this.selectData.id)
    },
    //对象日志记录查询
    getLogs(pageNumber, investId) {
      let rD = { pageNumber, investId }
      this.$api.util_search('questionnaire_log', rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c日志:`, 'color: #f00;', _R)
          _R.forEach(x1 => {
            // x1.imgList_ = x1.imgList.map(x2 => this.puUrl_x + '/user/img/' + x2)
            x1.imgList_ = x1.imgList.map(x2 => this.puUrl_x + '/' + x2)
          })
          this.logData = _R
          this.pageData_log.total = res.data.size
          this.pageData_log.pageSize = res.data.pageSize
        } else { this._status(res.data) }
      })
    },
    // #endregion

    getData(rD = {}) {
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c列表数据:`, 'color: #f00;', _R)
          // this.tableData = _R.map(x => ({
          //   ...x,
          //   nameT: x.name,
          //   phoneT: x.phone,
          //   houseT: x.house,
          //   addressT: x.address === '其他' ? x.address_other : x.address
          // }))
          const arr = []
          for (let i1 = 0; i1 < _R.length; i1++) {
            const x1 = _R[i1]
            x1.nameT = x1.name
            x1.phoneT = x1.phone
            x1.houseT = x1.house
            x1.addressT = x1.address === '其他' ? x1.address_other : x1.address
            x1.personHasJobT = x1.hostInfo.personHasJob
            x1.jobWithT = x1.hostInfo.jobWith
            x1.trainWishT = x1.hostInfo.trainWish
            x1.users = [...new Set([
              x1.name,
              ...x1.familyInfoList.filter(x1 => x1.name).map(x => x.name)
            ])]
            x1.tels = [...new Set([
              x1.phone,
              ...x1.familyInfoList.filter(x1 => x1.phone).map(x => x.phone)
            ])]
            x1.member = false
            arr.push(x1)
            if (x1.familyInfoList.length) {
              x1.familyInfoList.forEach(x2 => {
                arr.push({
                  ...x1,
                  nameT: x2.name,
                  phoneT: x2.phone,
                  houseT: '',
                  addressT: '',
                  personHasJobT: x2.personHasJob,
                  jobWithT: x2.jobWith,
                  trainWishT: x2.trainWish,
                  member: true,
                })
              })
            }
          }
          this.tableData = arr
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
    const powerStr = powerMap[this.sign]
    const mapList = ['search','create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.section-filter1{display: flex;padding: 20px;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;width: 100px;text-align: right;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}



.subtitle{
  width: 250px;height: 32px;line-height: 32px;margin-bottom: 18px;margin-left: 60px;
  display: flex;align-items: center;justify-content: space-between;position: relative;
  &::after {
    content: '';display: inline-block;width: 12px;height: 12px;background: #1E9FFF;
    border-radius: 50%;position: absolute;left: -20px;
  }
  .btns{display: flex;width: 68px;}
  .icon{cursor: pointer;font-size: 24px;}
  .icon:hover{color: #1E9FFF}
  .ml20{margin-left: 20px;}
}
/deep/.el-input.is-disabled .el-input__inner,
/deep/.el-textarea.is-disabled .el-textarea__inner,
/deep/.el-radio__input.is-disabled+span.el-radio__label{background: transparent;color: #606266}
/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner{background: #409EFF;border-color: #409EFF;}
/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner::after{background: #fff;}





.el-textarea .el-textarea__inner {resize: none;}
/deep/.info-input .disabled .el-upload--picture-card {display: none}
.info-input .el-tabs--border-card > .el-tabs__content {padding: 10px 0 10px 0!important;}


// 禁止勾选
/deep/.el-checkbox.is-disabled {display: none;}
</style>